@if (isQuickAddOpen()) {
<div class="qa-overlay" (click)="isQuickAddOpen.set(false)" role="button" tabindex="0" (keydown.enter)="isQuickAddOpen.set(false)" (keydown.space)="$event.preventDefault(); isQuickAddOpen.set(false)"> <!-- NOSONAR: click-outside-to-dismiss backdrop; wraps role=dialog content, cannot become a native button -->
  <div class="qa-modal" (click)="stopProp($event)" (keydown.enter)="stopProp($event)" (keydown.space)="$event.preventDefault(); stopProp($event)">
    <div class="qa-search-bar">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input #qaSearchInput type="text" placeholder="Search actions... or press a letter shortcut"
        [value]="quickAddQuery()" (input)="onQuickAddSearchInput($any($event.target).value)" autofocus>
      <button class="qa-esc" (click)="isQuickAddOpen.set(false)"
        style="cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 4px; box-sizing: border-box; background: transparent; border: none; color: #94a3b8;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="qa-grid">
      <button class="qa-item" [class.active]="activeQaIndex() === 0" [class.qa-hidden]="!isQuickAddItemVisible(0)"
        (mouseenter)="activeQaIndex.set(0)" (click)="executeQuickAction(0)">
        <div class="qa-icon-box qa-purple">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="23" y1="11" x2="17" y2="11"></line>
          </svg>
        </div>
        <div class="qa-text">
          <h4>Add Client</h4>
          <span>Register a new client</span>
        </div>
        <div class="qa-shortcut">C</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 1" [class.qa-hidden]="!isQuickAddItemVisible(1)"
        (mouseenter)="activeQaIndex.set(1)" (click)="executeQuickAction(1)">
        <div class="qa-icon-box qa-teal">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
            <polyline points="9 14 11 16 15 12"></polyline>
          </svg>
        </div>
        <div class="qa-text">
          <h4>New Task</h4>
          <span>Create a task for a client</span>
        </div>
        <div class="qa-shortcut">T</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 2" [class.qa-hidden]="!isQuickAddItemVisible(2)"
        (mouseenter)="activeQaIndex.set(2)" (click)="executeQuickAction(2)">
        <div class="qa-icon-box qa-amber">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </div>
        <div class="qa-text">
          <h4>{{ applyCustomLabels('New Deadline') }}</h4>
          <span>Set a compliance deadline</span>
        </div>
        <div class="qa-shortcut">D</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 3" [class.qa-hidden]="!isQuickAddItemVisible(3)"
        (mouseenter)="activeQaIndex.set(3)" (click)="executeQuickAction(3)">
        <div class="qa-icon-box qa-blue">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </div>
        <div class="qa-text">
          <h4>Compose Email</h4>
          <span>Send a message to a client</span>
        </div>
        <div class="qa-shortcut">E</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 4" [class.qa-hidden]="!isQuickAddItemVisible(4)"
        (mouseenter)="activeQaIndex.set(4)" (click)="executeQuickAction(4)">
        <div class="qa-icon-box qa-green">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
        </div>
        <div class="qa-text">
          <h4>New Invoice</h4>
          <span>Raise an invoice for work</span>
        </div>
        <div class="qa-shortcut">I</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 5" [class.qa-hidden]="!isQuickAddItemVisible(5)"
        (mouseenter)="activeQaIndex.set(5)" (click)="executeQuickAction(5)">
        <div class="qa-icon-box qa-rose">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <div class="qa-text">
          <h4>Log Time</h4>
          <span>Record billable hours</span>
        </div>
        <div class="qa-shortcut">L</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 6" [class.qa-hidden]="!isQuickAddItemVisible(6)"
        (mouseenter)="activeQaIndex.set(6)" (click)="executeQuickAction(6)">
        <div class="qa-icon-box qa-orange">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <div class="qa-text">
          <h4>{{ getCustomLabel('Schedule') }} Meeting</h4>
          <span>Book a client appointment</span>
        </div>
        <div class="qa-shortcut">M</div>
      </button>

      <button class="qa-item" [class.active]="activeQaIndex() === 7" [class.qa-hidden]="!isQuickAddItemVisible(7)"
        (mouseenter)="activeQaIndex.set(7)" (click)="executeQuickAction(7)">
        <div class="qa-icon-box qa-slate">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
          </svg>
        </div>
        <div class="qa-text">
          <h4>Run Report</h4>
          <span>Generate a practice report</span>
        </div>
        <div class="qa-shortcut">R</div>
      </button>
    </div>

    <div class="qa-footer">
      <div class="qa-nav-hints">
        <span class="hint-key">↑↓</span> navigate &middot; <span class="hint-key">↵</span> select &middot;
        letter key
        to jump directly
      </div>
      <div class="qa-count">{{ quickAddVisibleCount() }} actions</div>
    </div>
  </div>
</div>
}
